import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyDirectorship, Director } from '../../../core/models';
import { SelectionModel } from '@angular/cdk/collections';
import { CompanyStats } from '../../../core/models/company-stats';
import { Router } from '@angular/router';
import { UserSubscription } from '../../../modules/auth';
import { methodology } from '../../../core/constants/methodology';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/tooltip';

@Component({
  selector: 'app-directorship-profile',
  templateUrl: './directorship-profile.component.html',
  styleUrls: ['./directorship-profile.component.scss'],
  providers: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class DirectorshipProfileComponent {
  @Input() directorship: CompanyDirectorship;
  @Input() subscription: UserSubscription | null;
  @Input() director: Director;

  displayedColumns: string[] = [
    'year',
    'influence',
    'ebitda',
    'carbon',
    'tsr',
    'controversies',
    'is_expanded',
  ];
  expandedSelection = new SelectionModel<CompanyDirectorship>(true, []);
  constructor(
    public activeModal: NgbActiveModal,
    private readonly router: Router
  ) {}

  filterStats(stat: CompanyStats, id_company: number) {
    if (!id_company) return true;
    return stat.id_company === id_company;
  }

  filterStatsOther(stat: CompanyStats, year: number) {
    return year === stat.year;
  }

  closeModal() {
    this.activeModal.dismiss('Cross click');
  }

  averageInfluence(stats: CompanyStats[]) {
    // Calculate the average influence
    const influenceSum = stats.reduce(
      (sum, stats) => sum + stats.career_influence,
      0
    );
    return influenceSum / stats.length;
  }
  isExpandable(stat: CompanyStats, director: Director): boolean {
    return !!director.stats.find(otherStat => {
      return stat.year === otherStat.year;
    });
  }

  groupDirectorStats(stats: CompanyStats[]) {
    const headerStats: CompanyStats[] = [];
    for (let year = new Date().getFullYear(); year >= 2018; year--) {
      const stat = stats.find(_stat => _stat.year === year);
      if (stat) headerStats.push(stat);
    }
    return headerStats;
  }

  viewCompany(company: any) {
    this.closeModal();
    this.router.navigate(['/company', company.id, company.issuer_name]);
  }

  protected readonly methodology = methodology;
}
